import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store/'
import axios from 'axios'

const rendertron = require('rendertron-middleware')
Vue.config.productionTip = false

if (localStorage.token) {
  store.dispatch('user/applyToken', localStorage.token)
}

router.beforeEach((to, from, next) => {
  //--------------- rendertron -------
  // const BOTS = rendertron.botUserAgents.concat('googlebot');
  // const BOT_UA_PATTERN = new RegExp(BOTS.join('|'), 'i');

  // rendertron.makeMiddleware({
  //     proxyUrl: 'https://trailers-dot-my-project-1498044310206.appspot.com/render',
  //     userAgentPattern: BOT_UA_PATTERN
  //   })
  //----------------------------------

  if (!localStorage.token && to.meta.requiresAuth) {
    //![ '/login', '/signup','/', '/order_form','/orders/' ].includes(to.path)) {
    next({ path: '/login' })
  }
  next()
})

axios.interceptors.request.use(function(config) {
  if (localStorage.token) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.token
  } else {
    config.headers['Authorization'] = null
  }
  return config
})

axios.interceptors.response.use(
  function(response) {
    const path = response.config.url.substr(process.env.VUE_APP_API_URL.length)

    if (
      !localStorage.token &&
      !['/login', '/signup', '/fields/active', '/images/thumbnail', '/images/original'].some(item =>
        path.startsWith(item)
      )
    ) {
      router.push({ path: '/login' })
      return false
    }
    return response
  },
  function(error) {
    if (error.response.status === 401) {
      router.push({ path: '/login' })
    }
    return Promise.reject(error)
  }
)
new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
